import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { ToastType } from "@/enums/toast";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { displayErrorToast, displayToast } from "@/utils/toast";

export const useDeleteProvider = () => {
  const authContext = useAuth();
  const { workspaceId } = useParams();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      fetch(`${ENDPOINTS.providers(workspaceId ?? "")}/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authContext?.userToken}`,
        },
      }).then(handleResponse), // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onError: (error: unknown) => {
      displayErrorToast("Error deleting provider");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providers"] });
      displayToast("Provider deleted", ToastType.success);
    },
  });
};
